import styled from 'styled-components';
import { Media } from 'enums';
import { Text } from '../Text';

type IBackTitleProps = {
  isDescriptionFirst?: boolean;
};

export const BackTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const BackTitleIcon = styled.img`
  transform: rotate(90deg);
  width: 24px;
  height: 24px;
  margin-right: 16px;

  @media ${Media.notebook} {
    display: none;
  }

  &:active {
    filter: brightness(0) saturate(100%) invert(82%) sepia(18%) saturate(5217%)
      hue-rotate(2deg) brightness(111%) contrast(101%);
  }
`;

export const BackTitleHeader = styled(Text)`
  word-break: break-word;
`;

export const BackTitleDescription = styled(Text)<IBackTitleProps>`
  word-break: break-word;
  margin: ${({ isDescriptionFirst }) =>
    isDescriptionFirst ? '0 0 8px' : '4px 0 0'};
`;

export const BackTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
